import {Portal} from './components/Portal'
import useCurrentApp from './hooks/useCurrentApp'
import useProfile from './hooks/useProfile'
import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import useFavoriteApps from './hooks/useFavoriteApps'
import {pathToApp, pathToFavorite} from './util/navigation'

export const HomeApp = () => {
  const [profile] = useProfile()
  const [currentApp] = useCurrentApp()
  const [favorites] = useFavoriteApps()
  const navigate = useNavigate()

  useEffect(() => {
    if (currentApp) {
      return
    }
    const startupFavorite = favorites.find(
      (f) => f.id === profile?.startupApp.favoriteId
    )
    if (startupFavorite?.id) {
      navigate({pathname: pathToFavorite(startupFavorite.id)})
      return
    }

    if (profile?.startupApp.module && profile.startupApp.app) {
      navigate({
        pathname: pathToApp(profile.startupApp.module, profile.startupApp.app)
      })
    }
  }, [currentApp?.app, favorites, profile])

  return <Portal></Portal>
}
